import React, { useState, useEffect } from 'react'; // Importamos hooks
import { Link } from 'react-router-dom';

import '../../static/Header.css';
import '../../static/Global.css';

function Header() {
  const [cartCount, setCartCount] = useState(0);

  // Función para calcular la cantidad total de productos
  const updateCartCount = () => {
    const cart = JSON.parse(localStorage.getItem('mediexpress_cart')) || [];
    const totalItems = cart.reduce((acc, item) => acc + item.cantidad, 0);
    setCartCount(totalItems);
  };

  useEffect(() => {
    // 1. Cargar conteo inicial
    updateCartCount();

    // 2. Escuchar cambios en otras pestañas (opcional pero recomendado)
    window.addEventListener('storage', updateCartCount);

    // 3. Crear un evento personalizado para cuando agregamos productos en la misma pestaña
    window.addEventListener('cartUpdated', updateCartCount);

    return () => {
      window.removeEventListener('storage', updateCartCount);
      window.removeEventListener('cartUpdated', updateCartCount);
    };
  }, []);

  return (
    <header className="header">
      <div className="header__logo">
        <h1><Link to="/">NovaTech</Link></h1>
      </div>

      <section className="header__actions">
        {/* BOTÓN DE CARRITO CON CONTADOR */}
        <Link className="link-outline cart-icon-container" to="/carrito/ver" title="Carrito">
          <i className="fa-solid fa-cart-shopping"></i>
          {cartCount > 0 && (
            <span className="cart-badge">{cartCount}</span>
          )}
        </Link>

        {/* BOTÓN DE LOGIN (Solo icono) */}
        <Link className="link-outline btn-login-icon" to="/Login" title="Entrar">
          <i className="fa-solid fa-user"></i>
        </Link>
      </section>

    </header>
  );
}

export default Header;